import { capitalize } from "@/lib/utils";
import { setMyCommunityCurrView, setPropertyData } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetBomUsersList, useGetPropertiesByCommunity } from "@/services";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { USERS, VIEW_PROPERTY } from "../consts";

const useProperties = () => {
  const [globalFilter, setGlobalFilter] = useState("");
  const dispatch = useDispatch();

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const id = communityDetail?.communityId;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  //get properties
  const { data: propertiesData, isLoading: isLoadingProperties } =
    useGetPropertiesByCommunity({
      communityId: id as string,
    });

  const { data: bomUserList, isLoading: isLoadingBom } = useGetBomUsersList({
    communityId: id as string,
  });

  // Define Table Columns
  const columns = [
    {
      accessorKey: "displayId",
      header: "Property ID",
      accessorFn: (row: any) => String(row.displayId),
    },
    {
      accessorKey: "name",
      header: "Property Name",
      accessorFn: (row: any) => String(row?.name || ""),
    },
    {
      accessorKey: "unitNumber",
      header: "Unit Number",
      accessorFn: (row: any) => String(row?.unitNumber || ""),
    },
    {
      accessorKey: "occupancyId",
      header: "Ownership ID",
      accessorFn: (row: any) => String(row?.occupancyId || ""),
    },
    {
      accessorKey: "occupancyType",
      header: "Residency Type",
      accessorFn: (row: any) => {
        return row?.occupancyType ? capitalize(row?.occupancyType) : "";
      },
    },
    {
      accessorKey: "occupancyUserName",
      header: "Current Occupant",
      accessorFn: (row: any) => String(row?.occupancyUserName || ""),
    },
    {
      accessorKey: "bomPosition",
      header: "BM Position",
      accessorFn: (row: any) =>
        bomUserList?.data?.find(
          (data: any) => row?.occupancyUserId == data?.userId
        )?.positionName,
    },
    {
      accessorKey: "userCount",
      header: "# of Users",
      cell: ({ row }: any) => {
        return row?.original?.userCount ? (
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              dispatch(setPropertyData(row.original));
              dispatch(setMyCommunityCurrView(USERS));
            }}
            className="text-blue-500 hover:text-blue-600 cursor-pointer px-3"
          >
            {String(row?.original?.userCount)}
          </div>
        ) : (
          <div className="px-3">{"0"}</div>
        );
      },
    },
  ];

  const onRowClick = (row: any) => {
    // navigate(`${row.original.propertyId}/view`);
    dispatch(setPropertyData(row.original));
    dispatch(setMyCommunityCurrView(VIEW_PROPERTY));
  };

  const onCancel = () => {
    dispatch(setMyCommunityCurrView(""));
  };

  return {
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingProperties,
    propertiesData,
    communityDetail,
    onRowClick,
    isLoadingBom,
    onCancel,
  };
};

export default useProperties;
